module.exports = __webpack_public_path__ + "cd15b8ba06f5b1ca64b4855c6e4701a2.MP3";